import React from "react";

const DaySelector = ({ onDaysToggled, initial, initialDays }) => {
    const days = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
    ];

    const onDayClick = (index) => {
        const clickedDay = days[index];
        const selectedDays = Array.isArray(initialDays) ? initialDays : [];
        const selectedSet = new Set(selectedDays);

        if (selectedSet.has(clickedDay)) {
            selectedSet.delete(clickedDay);
        } else {
            selectedSet.add(clickedDay);
        }

        const nextDays = days.filter((day) => selectedSet.has(day));
        onDaysToggled(nextDays);
    };

    const getToggleStyle = (toggle) => {
        if (initial) {
            const baseStyle = {
                borderStyle: "solid",
                borderRadius: "25px",
                borderWidth: "1px",
                width: "30px",
                height: "30px",
                textAlign: "center",
                paddingTop: "5px",
                marginRight: "5px",
            };

            if (toggle) {
                return {
                    ...baseStyle,
                    backgroundColor: "grey",
                    color: "white",
                };
            } else {
                return {
                    ...baseStyle,
                    backgroundColor: "white",
                    color: "grey",
                };
            }
        } else {
            if (toggle) {
                return {
                    backgroundColor: "grey",
                    color: "white",
                    display: "in-line",
                    border: "solid",
                    width: "fit-content",
                };
            } else {
                return {
                    backgroundColor: "white",
                    color: "grey",
                    display: "in-line",
                    width: "fit-content",
                };
            }
        }
    };

    return (
        <div
            style={{
                display: "flex",
                flexWrap: "nowrap",
                flexDirection: "row",
                justifyContent: "space-between",
            }}
        >
            {days.map((name, index) => (
                <div
                    key={index}
                    style={getToggleStyle(
                        Array.isArray(initialDays) &&
                            initialDays.includes(name),
                    )}
                    onClick={() => onDayClick(index)}
                >
                    {initial ? name.charAt(0) : name}
                </div>
            ))}
        </div>
    );
};

export default DaySelector;
